import React from "react"

export const Loading = ({ text = "One sec..." }) => {
  return <p>{text}</p>
}
